import React from 'react';

const testimonialsData = [
  {
    id: 1,
    text: "Fast setup and the booth attendant was fantastic! They instantly texted the digital copies to our phones, which made sharing the memories so easy. Super pleased with Disco Duck Events and would highly recommend them for any event!",
    name: "Emily EK",
    role: "Olathe, KS",
  },
  {
    id: 2,
    text: "Prompt, easy to work with, affordable and professional! They showed up on time and ready to go!",
    name: "Austin H",
    role: "Crossroads, KCMO",
  },
  {
    id: 3,
    text: "The photobooth was an absolute blast! The props were hilarious and the prints were exactly as imagined. Defo recommend!",
    name: "Blake F",
    role: "Leawood, KS",
  },
];

export default function Testimonials() {
  return (
    <section className="testimonials" id="testimonials">
      <h2 className="testimonials-title">What Our Clients Say</h2>

      <div className="testimonials-grid">
        {testimonialsData.map((testimonial) => (
          <div className="testimonial-card" key={testimonial.id}>
            <p className="testimonial-quote">&ldquo;{testimonial.text}&rdquo;</p>
            <div className="testimonial-author">
              <p className="testimonial-name">{testimonial.name}</p>
              <p className="testimonial-role">{testimonial.role}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
